{
  "enum": {
    "IxfReportsV1ReportStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxfReportsV1ReportQueryServiceReportListFilterableFields": {
      "data": {
        "spec": {
          "endDate": "End Date",
          "startDate": "Start Date",
          "type": "Type"
        }
      },
      "reportId": "Report",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxfReportsV1ReportEventType": {
      "replaced": "Replaced",
      "uploaded": "Uploaded"
    }
  },
  "sortEnum": {
    "IxfReportsV1ReportQueryServiceReportListSortableFields": {
      "data": {
        "spec": {
          "endDate": "End Date",
          "startDate": "Start Date"
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}